export default "__VITE_ASSET__gjUzZAsl__"